import React from 'react';
import { Col } from 'react-bootstrap';

export const ProjectCard = ({ title, description, imgUrl, githubLink, liveDemoLink }) => {
    return (
        <Col size={12} sm={6} md={4}>
            <div className="proj-imgbx">
                <img src={imgUrl} alt={title} />
                <div className="proj-txtx">
                    <h4>{title}</h4>
                    <span>{description}</span>
                    <div className="btn-container">
                        <button className="btn btn-color-2 project-btn" onClick={() => window.location.href = githubLink}>
                            GitHub
                        </button>
                        <button className="btn btn-color-2 project-btn" onClick={() => window.location.href = liveDemoLink}>
                            Live Demo
                        </button>
                    </div>
                </div>
            </div>
        </Col>
    );
}